export const getBudgetEditorStyle = () => ({
  form: {
    fontSize: '14px !important',
    '& .error': {
      color: '#a80000',
    },
    '& .budget-amount-editor': {
      '& .budget-input': {
        '& input': {
          width: 'auto',
          display: 'inline-block',
          marginRight: '10px',
          verticalAlign: 'top',
        },
        '& div[role="alert"]': {
          marginTop: 5,
        },
      },
      '& .shared-budget-edit-budget-message-per-day': {
        position: 'absolute',
        left: 205,
        whiteSpace: 'nowrap',
        margin: '6px 12px',
      },
    },
    '& .budget-type-container': {
      paddingTop: '16px',
      marginRight: '32px',
      marginBottom: '5px',
    },
    '& .budget-editor-with-landscape': {
      marginRight: '24px',

      '& .budget-type-container': {
        borderTop: '1px solid #CCCCCC',
        marginTop: '10px',
      },
      '& .landscape-table': {
        '& .tip-message, & .error-message': {
          '& span.iconba-Warning': {
            marginRight: '5px',
            color: '#D83B01',
          },
          marginBottom: '16px',
          marginTop: '16px',
          marginLeft: '8px',
        },
        '& table': {
          width: '100%',
          '& input': {
            marginRight: '8px',
          },
          '& input[type=\'radio\']': {
            position: 'relative',
            marginLeft: '4px',
          },
          '& th, & td': {
            '&.selected': {
              background: 'rgba(237, 237, 237, 0.5)',
            },
          },
          '& td.user-input-cell': {
            paddingLeft: '1px',
          },
          '& tr': {
            height: '32px',
          },
          '& th': {
            '&.selected': {
              color: '#333',
              fontWeight: '500',
            },
          },
          '& td:last-child': {
            paddingRight: '5px',
          },
          '& .user-input': {
            display: 'inline',
            position: 'relative',
            '& .currency-symbol': {
              position: 'absolute',
              top: '-1px',
              left: '6px',
              color: '#666666',
            },
            '& input': {
              paddingLeft: '16px',
              borderWidth: '1px',
              borderColor: '#BBB',
            },
            '& .symbol-size-2 + input': {
              paddingLeft: '25px',
            },
            '& .symbol-size-3 + input': {
              paddingLeft: '35px',
            },
            '& .error': {
              color: '#A80000 !important',
              fontSize: 'inherit',
            },
          },
          '& tbody': {
            '& tr.selected': {
              backgroundColor: '#F3F2F1',
            },
          },
          '& thead': {
            '& span': {
              fontWeight: '500',
            },
          },
        },
      },
    },
    '& .inline-budget-edit-type': {
      marginTop: '5px',
    },
    '& span.bold': {
      fontWeight: 1000,
    },
    '& .alert-budget-button': {
      marginLeft: '10px',
      paddingTop: '5px',
      '& button': {
        color: 'black',
        fontSize: '13px',
        fontWeight: 500,
        borderColor: '#edebe9',
      },
    },
  },
});
